
export default {
  name: 'OrganismDownloadBrochureModal'
}
